import "../../styles/dashboard.css";
import { useLocation, useNavigate } from "react-router-dom";
import { capitalizeWords } from "./capitalizeWords";
import * as XLSX from "xlsx";
import formatDate from "./dateUtils";

const LabourCardDetails = () => {
  const location = useLocation();
  const labourCardData = location.state?.labourCardData;
  const navigate = useNavigate();



  const getExpiryDate = (documents) => {
    const labourCardDocument = documents.find((doc) => doc.name === "Labour Card");
    return labourCardDocument ? labourCardDocument.expiryDate : "";
  };

  const getDaysLeft = (documents) => {
    const labourCardDocument = documents.find((doc) => doc.name === "Labour Card");
    if (labourCardDocument && labourCardDocument.expiryDate) {
      const expiryDate = new Date(labourCardDocument.expiryDate);
      const today = new Date();
      const timeDifference = expiryDate - today;
      const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      return daysLeft >= 0 ? daysLeft : 0;
    }
    return "";
  };

  const handleUpdateLabourCardDetails = (id) => {
    const employeeDataToUpdate = labourCardData.find(
      (employee) => employee.employee_information_id === id
    );
    if (employeeDataToUpdate) {
      navigate(`/labourcardupdate/${id}`, {
        state: { labourCardToUpdate: employeeDataToUpdate },
      });
    }
  };

  const downloadDataAsExcel = () => {
    const filename = "LabourCardDataExpiry.xlsx";
    const data = labourCardData.map((employee, index) => ({
      "SL No.": index + 1,
      "Employee ID": employee.employee_id,
      "Employee Details": capitalizeWords(employee?.employee_full_name),
      "Company Name": capitalizeWords(
        employee?.roles[0]?.company[0]?.company_name
      ),
      
      "Expiry Date": getExpiryDate(employee.documents),
      "Days Left": getDaysLeft(employee.documents),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Visa Data");
    XLSX.writeFile(workbook, filename);
  };

  return (
    <div className="board__layout">
      <div className="section-header">
        <h1>Labour Card Expiry Details</h1>
        <button className="expiry_download-btn" onClick={downloadDataAsExcel}>
          Download
        </button>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>SL No.</th>
              <th>Employee ID</th>
              <th>Employee Details</th>
              <th>Company Name</th>            
              <th>Expiry Date</th>
              <th>Days Left</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {labourCardData.map((employee, index) => {
              const id = employee.employee_information_id;

              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{employee.employee_id}</td>
                  <td>
                    <div className="leave_empName">
                      {capitalizeWords(employee?.employee_full_name)}
                    </div>
                    <div className="leave_designation">
                      {capitalizeWords(employee?.roles[0]?.role_name)}
                    </div>
                  </td>

                  <td>
                    {capitalizeWords(
                      employee?.roles[0]?.company[0]?.company_name
                    )}
                  </td>
                  
                  <td>{formatDate(getExpiryDate(employee.documents))}</td>
                  <td>{getDaysLeft(employee.documents)}</td>
                  <td>
                    <div className="visa_expiry-edit">
                      <button
                        onClick={() =>
                          handleUpdateLabourCardDetails(
                            employee.employee_information_id
                          )
                        }
                      >
                        Update
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LabourCardDetails;
